import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'synfrastructure';
import { editSettings, fetchSettings } from './actions';
import { fetchCourses } from '../courses/actions';
import { fetchTvShows } from '../tv/actions';
import { SubmissionError } from 'redux-form';
import { formatValidationErrors } from '../common/utils/getApiReducer';
import clone from 'lodash/clone';

import Icon from '../common/icons/Icon';
import Loading from '../common/components/Loading';
import EditSettingsForm from './EditSettingsForm';

import {
  selectFeaturedCourse,
  selectFeaturedMsCourse,
  selectFeaturedTvShow,
  selectGiftSubscriptionPrice,
  selectMsCertificationCourse,
  selectPublicCourses,
  selectSixtyDayCourse,
} from './selectors';

class Settings extends Component {
  state = {
    editSettingsModalVisible: false,
  };

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(fetchSettings());
    dispatch(fetchCourses());
    dispatch(fetchTvShows());
  }

  toggleEditSettingsModal = () => {
    this.setState(state => ({ editSettingsModalVisible: !state.editSettingsModalVisible }));
  };

  onEditSettingsSubmit = values => {
    const { dispatch } = this.props;
    const submitValues = clone(values);

    submitValues.giftSubscriptionPrice = Math.round(parseFloat(submitValues.giftSubscriptionPrice).toFixed(2) * 100);

    return dispatch(editSettings(submitValues)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.toggleEditSettingsModal();
      }
    });
  };

  render() {
    const {
      courses,
      loaded,
      publicCourses,
      shows,
      featuredCourse,
      featuredMsCourse,
      featuredShow,
      giftSubscriptionPrice,
      msCertificationCourse,
      sixtyDayCourse,
    } = this.props;
    const { editSettingsModalVisible } = this.state;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <div className="admin-paper">
        {editSettingsModalVisible ? (
          <Modal isVisible={editSettingsModalVisible} onClose={this.toggleEditSettingsModal}>
            <EditSettingsForm
              courses={courses.get('data')}
              initialValues={{
                featuredCourseId: featuredCourse ? featuredCourse.get('id').toString() : '',
                featuredMsCourseId: featuredMsCourse ? featuredMsCourse.get('id').toString() : '',
                featuredShowId: featuredShow ? featuredShow.get('id').toString() : '',
                giftSubscriptionPrice: giftSubscriptionPrice ? (giftSubscriptionPrice / 100).toFixed(2) : 0,
                msCertificationCourseId: msCertificationCourse ? msCertificationCourse.get('id').toString() : '',
                sixtyDayCourseId: sixtyDayCourse ? sixtyDayCourse.get('id').toString() : '',
              }}
              onCancel={this.toggleEditSettingsModal}
              onSubmit={this.onEditSettingsSubmit}
              publicCourses={publicCourses}
              shows={shows.get('data')}
            />
          </Modal>
        ) : null}
        <div className="admin-paper__header">
          <h3>Settings</h3>
          <button onClick={this.toggleEditSettingsModal} className="button button--theme--outline button--icon">
            <Icon icon="Pencil" />Edit Settings
          </button>
        </div>
        <ul className="admin-paper__list">
          <li>Featured Course (non-MS): {featuredCourse ? featuredCourse.get('name') : 'Not Set'}</li>
          <li>Featured Course (MS): {featuredMsCourse ? featuredMsCourse.get('name') : 'Not Set'}</li>
          <li>Featured TV Show: {featuredShow ? featuredShow.get('name') : 'Not Set'}</li>
          <li>
            Movement Specialist Certification Course:{' '}
            {msCertificationCourse ? msCertificationCourse.get('name') : 'Not Set'}
          </li>
          <li>60-Day Course: {sixtyDayCourse ? sixtyDayCourse.get('name') : 'Not Set'}</li>
          <li>Gift Subscription Price: {giftSubscriptionPrice ? `$${(giftSubscriptionPrice / 100).toFixed(2)}` : 'Not Set'}</li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const loaded =
    state.settings.settings.get('loaded') && state.courses.courses.get('loaded') && state.tv.shows.get('loaded');

  return {
    courses: state.courses.courses,
    featuredCourse: selectFeaturedCourse(state),
    featuredMsCourse: selectFeaturedMsCourse(state),
    featuredShow: selectFeaturedTvShow(state),
    giftSubscriptionPrice: selectGiftSubscriptionPrice(state),
    loaded,
    msCertificationCourse: selectMsCertificationCourse(state),
    publicCourses: selectPublicCourses(state),
    sixtyDayCourse: selectSixtyDayCourse(state),
    shows: state.tv.shows,
  };
};

export default connect(mapStateToProps)(Settings);



// WEBPACK FOOTER //
// ./src/settings/Settings.js